import PropTypes from "prop-types"
import styled, { css } from "styled-components"
import { handleMobileSize } from "./helpers"
import media from "@styles/media"
import Theme from "@styles/theme"
import { cssConfig } from "@utils/css-validator"

// Use div's font sizing logic instead
const Paragraph = styled.p.withConfig(cssConfig)`
  color: ${props => props.color ?? props.theme.color.blue700};
  text-align: ${props => (props.center ? "center" : props.textAlign)};
  font-weight: ${props => props.fontWeight};
  margin: ${props => props.margin};
  font-style: ${props => props.fontStyle};
  padding: ${props => props.padding};
  line-height: ${props => props.lineHeight ?? "1.7"};
  max-width: ${props => props.maxWidth};
  opacity: ${props => props.opacity};

  font-size: ${({ inherit, fontSize }) => (inherit ? "inherit" : fontSize)};
  letter-spacing: ${props => props.letterSpacing};

  ${media.sm`
    margin: ${({ marginSm }) => marginSm};
	  font-size: ${({ inherit, fontSize, mobileScale }) =>
      inherit ? "inherit" : handleMobileSize(fontSize, mobileScale)};
    max-width: ${props => props.maxWidthSm};
  `}

  ${media.md`
    margin: ${({ marginMd }) => marginMd};
    max-width: ${props => props.maxWidthMd};
  `}

  ${media.sm_up`
	  font-size: ${({ inherit, fontSize, tabletScale }) =>
      inherit ? "inherit" : handleMobileSize(fontSize, tabletScale)};
	`}

	${media.md_up`
    font-size: ${({ inherit, fontSize }) => (inherit ? "inherit" : fontSize)};
	`}

  ${({ inherit }) =>
    inherit &&
    css`
      font-size: inherit;
      line-height: inherit;
    `}
`

Paragraph.defaultProps = {
  fontSize: Theme.defaults.fontSize.p,
  fontWeight: "400", // Is this needed?
  margin: "0", // Is this needed?
  padding: "0", // Is this needed?
  tabletScale: 0.9,
  mobileScale: 0.8,
}

Paragraph.propTypes = {
  color: PropTypes.string,
  center: PropTypes.bool,
  fontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  margin: PropTypes.string,
  marginSm: PropTypes.string,
  marginMd: PropTypes.string,

  padding: PropTypes.string,
  lineHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  maxWidth: PropTypes.string,
  maxWidthSm: PropTypes.string,
  maxWidthMd: PropTypes.string,

  fontStyle: PropTypes.string,
  fontSize: PropTypes.string,
  letterSpacing: PropTypes.string,
  inherit: PropTypes.bool,
  tabletScale: PropTypes.number,
  mobileScale: PropTypes.number,
  opacity: PropTypes.number,
}

export default Paragraph
